export default "__VITE_ASSET__Q5sWoM6R__"